// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1NzjS","clinicsSelect":"TableHeading_clinicsSelect__3XtPw"};